import PropTypes from 'prop-types';
import { useRef, useState } from 'react';

import arrowRightSti from '../../assets/images/arrowRightSti.svg';
import icon from '../../assets/images/documentFor.svg';
import sticersIcon from '../../assets/images/sticersIcons.svg';
import { getTotalCopies } from '../../utils/functions';
import styles from './styles/styles.module.css';

function UploadZone({ handleFileChange, type, stickers, onClickHandler }) {
  const inputRef = useRef(null);
  const [dragActive, setDragActive] = useState(false);
  const isStickers = type === 'stickers' || type === 'stickersset';
  const isStickersSet = type === 'stickersset';

  const handleClick = () => {
    inputRef.current.click();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragActive(false);

    const files = Array.from(e.dataTransfer.files);
    handleFileChange({ target: { files } });
  };

  return (
    <div
      role="button"
      tabIndex={0}
      className={`
        ${isStickers && !isStickersSet ? styles.dropZoneSti : styles.dropZone} 
        ${dragActive ? styles.active : ''} 
        ${stickers?.length > 0 && !isStickersSet ? styles.filled : ''}
         `}
      onClick={
        isStickers && !isStickersSet
          ? stickers?.length === 0
            ? handleClick
            : onClickHandler
          : handleClick
      }
      onDragOver={(e) => {
        e.preventDefault();
        setDragActive(true);
      }}
      onDragLeave={() => setDragActive(false)}
      onDrop={handleDrop}
    >
      <div className={styles.infoWrapper}>
        <img
          src={isStickers ? sticersIcon : icon}
          alt="Добавить документ"
          width={48}
          height={48}
        />
        <div style={{ width: '100%' }}>
          <p>{`${stickers?.length > 0 && !isStickersSet ? `Загружено ${stickers?.length} стикеров` : 'Нажмите или перетащите файлы в эту область для загрузки файлов'}`}</p>
          <span className={styles.inttSpan}>
            {stickers?.length > 0 && !isStickersSet ? (
              `Всего к печати: ${getTotalCopies(stickers)} копий`
            ) : (
              <span>
                Допустимые форматы: PDF. <br />
                Максимальный размер: 50 МБ
              </span>
            )}
          </span>
        </div>
        {stickers?.length > 0 && !isStickersSet ? (
          <div style={{ width: '100%', display: 'flex', justifyContent: 'end' }}>
            <img src={arrowRightSti} alt="Открыть список" width={24} height={24} />
          </div>
        ) : null}
      </div>
      <input
        ref={inputRef}
        type="file"
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
    </div>
  );
}

UploadZone.propTypes = {
  handleFileChange: PropTypes.func.isRequired,

  type: PropTypes.oneOf(['stickers', 'stickersset']),

  stickers: PropTypes.arrayOf(
    PropTypes.exact({
      id: PropTypes.string.isRequired,
      file: PropTypes.instanceOf(File).isRequired,
      name: PropTypes.string.isRequired,
      size: PropTypes.number.isRequired,
      copies: PropTypes.number.isRequired,
    })
  ),

  onClickHandler: PropTypes.func,
};
export default UploadZone;
